import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Layout, SectionMenu, Spin } from "../../design-system";
import { useUserState } from "../../common/UserContext";
import { getUsers } from "../../common/api/UserClient";
import { handleError } from "../../common/ErrorHandling";
import { User } from "../../types/UserGroup";
import { ProfileCard } from "./ProfileCard";
import { NotificationSettingsCard } from "./NotificationSettingsCard";
import classes from "./UserPreferencesView.module.less";

const { Header, Content } = Layout;

const SECTIONS = [
    { key: "profile", label: "Profile" },
    { key: "notifications", label: "Notifications" },
];

/** The current user's account: their profile and their notification settings, one section each. */
export const UserPreferencesView: React.FC = () => {
    const { me } = useUserState();
    const navigate = useNavigate();
    const { section = "profile" } = useParams();
    const [user, setUser] = useState<User>();

    useEffect(() => {
        if (!me.id) return;
        getUsers([me.id])
            .then((users) => setUser(users[0]))
            .catch(handleError);
    }, [me.id]);

    return (
        <Layout className={classes.layout}>
            <Header className={classes.header}>
                <h2 className={classes.title}>My Account</h2>
                <div className={classes.subtitle}>View and manage your account details</div>
            </Header>
            <Content className={classes.content}>
                <div className={classes.workspace}>
                    <SectionMenu
                        title="Settings"
                        items={SECTIONS}
                        selected={section}
                        onSelect={(key) =>
                            navigate(key === "profile" ? "/preferences" : `/preferences/${key}`)
                        }
                    />
                    <div className={classes.section}>
                        {section === "profile" &&
                            (user ? <ProfileCard user={user} onSaved={setUser} /> : <Spin />)}
                        {section === "notifications" && <NotificationSettingsCard />}
                    </div>
                </div>
            </Content>
        </Layout>
    );
};
